// HOC shared by both register and account flows
import { withEditEmergencyContactForm } from 'components/account/EmergencyContacts/Edit'

// presentational component specific to register flow
import UI from './UI'

// in reg flow, redirect to emergency contacts list
export default withEditEmergencyContactForm({
  redirect: '/emergency_contacts'
})(UI)
